/**
 * Who may see supplier cost, markup and gross profit.
 * Mirrors `can_view_cost` in backend/dependencies.py — roles that need it for
 * the job, plus anyone a super admin granted the "cost.view" permission.
 */
const COST_ROLES = ["super_admin", "hub_admin", "admin", "admin_accountant", "accountant"];

export const canViewCost = (user) => {
  if (!user) return false;
  if (COST_ROLES.includes(user.role)) return true;
  // "full" is the generic marker every user gets; cost needs the explicit grant.
  return (user.permissions || []).includes("cost.view");
};

export default canViewCost;
